import { useEffect } from 'react';

type ClickOutsideHandler = (event: MouseEvent | TouchEvent) => void;

export function useOnClickOutside(
  ref: React.RefObject<HTMLElement>,
  handler: ClickOutsideHandler
) {

  const showTooltip = () => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return { top: 0, left: 0 };

    const tooltipWidth = 220;
    const padding = 10;
    
    let left = rect.right + padding;
    let top = rect.top + rect.height / 2 - 20;
    
    // Adjust if tooltip goes off screen right
    if (left + tooltipWidth > window.innerWidth - padding) {
      left = rect.left - tooltipWidth - padding;
    }
    
    // Adjust if tooltip goes off screen left
    if (left < padding) {
      left = padding;
    }
    
    // Adjust if tooltip goes off screen top
    if (top < padding) {
      top = padding;
    }
    
    // Adjust if tooltip goes off screen bottom
    if (top + 80 > window.innerHeight - padding) {
      top = window.innerHeight - 80 - padding;
    }

    return { top, left }
  }

  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const el = ref.current;
      if (!el || el.contains(event.target as Node)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener); // for mobile

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);

  return { position: showTooltip() };
}
